import { Injectable, Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
  name: "tableItemType",
  standalone: false,
})
@Injectable({
  providedIn: "root",
})
export class TableItemTypePipe implements PipeTransform {
  private translationPrefix: string = "admin.nconnect.pipe.custom_global";

  constructor(private translateService: TranslateService) {}

  public transform(customerId: number | null): string {
    const type: string = customerId ? "custom" : "global";
    // Example output: Custom
    return this.translateService.instant(`${this.translationPrefix}.${type}`);
  }
}
